import type { CancelPolicyItem, ExistingOptionDefaultQuery, OptionNewItemQuery } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { OptionInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "optionID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type ProductOptionFormModel = AutoGeneratorForFormModel<OptionInputZodSchemaType, ExcludeKeys, QueryData>;

export type QueryData = {
	hotelPolicy: {
		cancelPolicy: CancelPolicyItem[];
		requiredPrepMillisecond: number;
	};
	connection: {
		planNameAndIDOptions: FormOptionType[];
	};
	discountList: ExistingOptionDefaultQuery["discountList"] | OptionNewItemQuery["discountList"];
};
